import { tw } from "@careinfo/tailwind";
import type { ColumnDef, Table } from "@tanstack/react-table";
import moment from "moment";
import NACell from "../Reusable/DataTable/NACell";
import TrackingCell from "../Reusable/DataTable/TrackingCell";

interface Props {
  checkedAllItems: boolean;
  handleSelectAll: (table: Table<any>) => void;
  isSelected: (value: string, order: string) => boolean;
  handleIndividualSelect: (value: string, order: string) => void;
}

export const getRemainningOrderColumn = ({
  checkedAllItems,
  handleSelectAll,
  isSelected,
  handleIndividualSelect,
}: Props): ColumnDef<any, any>[] => [
  {
    id: "select",
    header: ({ table }) => {
      return (
        <input
          type="checkbox"
          checked={checkedAllItems}
          onChange={() => handleSelectAll(table)}
          className={tw`cursor-pointer`}
        />
      );
    },
    cell: ({ row }) => (
      <input
        type="checkbox"
        checked={isSelected(row?.original?.id, row?.original?.order?.id)}
        onChange={() =>
          handleIndividualSelect(row?.original?.id, row?.original?.order?.id)
        }
        className={tw`cursor-pointer`}
      />
    ),
  },
  {
    header: "Date",
    accessorKey: "created",
    cell: ({ getValue }) => {
      return (
        <>
          {getValue() ? (
            <p>{moment(getValue()).format("YY-MM-DD HH:mm:ss")}</p>
          ) : (
            "N/A"
          )}
        </>
      );
    },
  },
  {
    header: "Waybill",
    accessorKey: "tracking_number",
    cell: TrackingCell,
  },
  {
    header: "Origin",
    accessorKey: "pickup_branch.name",
    cell: NACell,
  },

  {
    header: "Sender",
    accessorKey: "sender.full_name",
    cell: NACell,
  },
  {
    header: "Destination",
    accessorKey: "destination.name",
    cell: NACell,
  },

  {
    header: "Receiver",
    accessorKey: "receiver.full_name",
    cell: NACell,
  },
  {
    header: "Status",
    accessorKey: "delivery_status.name",
    cell: ({ row, getValue }: any) => {
      return (
        <>
          <p
            className={tw`uppercase whitespace-nowrap px-1 text-center rounded-md`}
            style={{
              background: row?.original?.delivery_status?.color,
            }}
          >
            {getValue()}
          </p>
        </>
      );
    },
  },
];
